export enum SettingsRoundnessLevel {
  SOLID = '0',
  SEMI_ROUNDED = '12',
  ROUNDED = '24'
}
